import {Box, Container, Text} from '@chakra-ui/react';
import {colors, useCustomerContext} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import ImageUI from 'ui/ImageUI';

import {AlertDialog, SupportButtons} from '.';

export const BlockedAccount: FC = () => {
  const {t} = useTranslation();
  const {customer, isLoadingGetting} = useCustomerContext();

  if (!customer.is_blocked || isLoadingGetting) return null;

  return (
    <Box display="block">
      <AlertDialog
        title={
          <Text align="center" fontSize="24px">
            {t('accountBlockedTitle')}!
          </Text>
        }
        isOpen={true}
        disableBtns
      >
        <Container maxW="2xl" centerContent>
          <ImageUI
            mr="15px"
            w="50px"
            pb={['15px', '25px']}
            borderRadius="10px"
            src="/icons/support.svg"
            alt="support"
          />
          <Text fontSize="14px" fontWeight="500" color={colors.textGray} mb="14px">
            {t('accountBlockedDescription').replace('{0}', customer.name)}
          </Text>
          <SupportButtons t={t} />
        </Container>
      </AlertDialog>
    </Box>
  );
};
